// TSS vite/04 §"Endpoint paths". baseURL ya incluye /api/v1.
// Estadísticas por entidad (admin-stats.md): donante / semen-toro / laboratorio.

export const statsPaths = {
    animal: (id) => `admin/animals/${id}/stats`,
    semen:  (id) => `admin/semen/${id}/stats`,
    lab:    (id) => `admin/labs/${id}/stats`,
    // Stats combinadas por cliente/finca (donors_kpi + recipients_kpi + report, 0045/0049).
    client: (id) => `admin/clients/${id}/stats`,
    farm:   (id) => `admin/farms/${id}/stats`,
};
